<template>
    <div class="body">
        <h1 class="package-title-ka"><p>默认手机号：{{ userPhone }}</p></h1>
        <van-row v-for="item in dataList" :key="item.id">
            <van-col :span="19">
                <div class="content">
                     <div class="congten-img"  >
                        <img src="./../../assets/home/24.png" alt="">
                    </div>
                    
                    <div class="title">
                        <div class="f-title">卡号：{{item.iccid}}</div>
                        <div class="f-title-s">状态：{{item.stateName}}</div>
                    </div>
                </div>
            </van-col>
            <van-col :span="5">
                <div class="exchange"  v-if="item.simDefault==0" @click="understand(item)">设为默认</div>
                <div class="exchange" @click="changePhone(item)">更改手机号</div>
            </van-col>
        </van-row>
        <van-popup v-model="popupVisible" position="center" round closeable :close-on-click-overlay="false" close-on-popstate>
            <div class="title">更改手机号</div>
            <van-cell-group>
                <van-field label-width="70px" label="手机号码:" v-model="verifiedInfo.userPhone"  maxlength="11"  placeholder="请输入11位手机号码" /> 
                <van-field label-width="70px" label="验证码:" v-model="verifiedInfo.smsCode" clearable maxlength="6"  placeholder="请输入验证码">
                    <van-button slot="button" type="primary" size="small" :disabled="smsFlag" class="codeBtn" @click="getSmsCode">{{btnTxt}}</van-button>
                </van-field>
            </van-cell-group>
            <mt-button type="primary" size="large" class="exchange sumbit" @click.prevent="sureVerifiedHandler">确定</mt-button>
        </van-popup>
    </div>
</template>
<script>
import { wxRequest } from '@/api/user'
import { Toast,Dialog } from 'vant';
import { runInThisContext } from 'vm';
export default {
    data(){
        return{
            popupVisible:false,
            dataList:[],
            verifiedInfo: {
                iccid:'',
                userPhone: '',
                smsCode:''
            },
            smsFlag:false,
            timer:null,
            userPhone:localStorage.getItem("userPhone"),
            btnTxt: '发送验证码',
        }
    },
    created(){
        this.init()
    },
    methods:{
        init(){
            var params = {
                userPhone: this.userPhone
            }
            wxRequest('/bindPhone/list',params, 'post').then(res => {
                if(res.data.code == 200){
                    this.dataList = res.data.data
                }else {
                    Toast.fail(res.data.message);
                }
            })
        },
        exchange(data){
            var params = {
                id:data.id
            }
            wxRequest('/applyChangeSim/show/to/apply',params, 'post').then(res => {
                if(res.data.code == 200){
                      Dialog.alert({title: "提示", message: '兑换成功'});
                    this.init()
                }else {
                    Toast.fail(res.data.message);
                }
            })
        },
        //设置默认手机号
        understand(data){
            var sendData={
                defaultIccid:data.iccid,
                iccid:data.iccid
            }
            wxRequest('/bindPhone/update/default',sendData, 'post').then(res => {
                if(res.data.code == 200){
                    Dialog.alert({title: "提示", message: '设置成功'});
                    this.init()
                }else {
                    Toast.fail(res.data.message);
                }
            })
        },
        changePhone(data){
            this.verifiedInfo.iccid = data.iccid
            this.smsFlag = false
            window.clearInterval( this.timer);
            this.btnTxt = '发送验证码';
            this.popupVisible = true
        },
        //获取验证码
        getSmsCode(){
            if(!this.verifiedInfo.userPhone || this.verifiedInfo.userPhone.length !== 11){
                Toast.fail('手机号码有误，请重新输入！');
                return 
            }
            const rulut = this.verifiedInfo.userPhone //加密
            var data = {
                userPhone: rulut
            }
            wxRequest("bindPhone/sms/code", data, "post").then(res => {
                if(res.data.code == 200){
                    var n = 60;
                    this.smsFlag = true          
                    this.btnTxt = '重新发送' + n +'s';
                    this.timer = window.setInterval(() => {   
                        n--;
                        this.btnTxt = '重新发送' + n +'s';
                        if(n < 1){
                            this.smsFlag = false
                            window.clearInterval( this.timer);
                            this.btnTxt = '发送验证码';
                        }
                    },1000)
                }else{
                    Dialog.alert({title: "提示", message:res.data.message});
                }
            })
        },
        //保存
        sureVerifiedHandler(){
            if(!this.verifiedInfo.userPhone || this.verifiedInfo.userPhone.length !== 11){
                Toast.fail('手机号码有误，请重新输入！');
                return 
            }
            if(!this.verifiedInfo.smsCode || this.verifiedInfo.smsCode.length !== 6){
                Toast.fail('验证码有误，请重新输入！');
                return 
            }
            wxRequest('/bindPhone/update/phone',this.verifiedInfo, 'post').then(res => {
                if(res.data.code == 200){
                    Dialog.alert({title: "提示", message: '更新成功'});
                    this.popupVisible = false
                    this.init()
                }else {
                    Toast.fail(res.data.message);
                }
            })
        }
    }
}
</script>
<style lang="less" scoped>
    .body{
        .package-title-ka {
            height: 46px;
            margin:0 15px;
            background: url("../../assets/img/topback.png") no-repeat;
            background-size: 100% 100%;
            padding:0 12px;
            font-size: 18px;
            font-weight: bold;
            color: #FFFFFF;
            display: flex;
            align-items: center;
        }
        .van-row{
            margin:10px;
            border-bottom:1px solid #FAFAFA;
            padding-bottom:16px;
            display: flex;
            align-items: center;
            .content{
                display: flex;
                align-items: center;
               .congten-img{
                    width: 40px;
                    height:40px;
                    text-align: center;
                    background: #FFF2FF;
                    border-radius:100%;
                    line-height:40px;
                    margin-right: 8px;
                    img{
                        width:30px;
                        vertical-align: middle;
                    }
               } 
               .title{
                .f-title{
                    // font-size:15px;
                    font-weight: 500;
                    margin-bottom:4px;
                }
                .f-title-s{
                    color: #999999;
                    font-size:12px;
                    margin-top:8px;
                }
               }
            }
            .van-col--5{
                padding-top: 12px;
            }
            
            .y-exchange{
                height:30px;
                width:80px;
                font-size: 14px;
                color:#FFF;
                line-height:30px;
                text-align: center;
                border-radius:15px;
                background: #D8D8D8;
            }
        }
        .van-popup{
            width:80%;
            height:46%;
            .van-cell-group{
                margin-top:20px;
            }
            .title{
                padding: 20px 0 0 20px;
                font-size: 18px;
            }
        }
        .exchange{
            height:30px;
            width:66px;
            font-size: 12px;
            color:#FFF;
            line-height:30px;
            text-align: center;
            cursor: pointer;
            margin-bottom:10px;
            border-radius:15px;
            background: -webkit-linear-gradient(to right,#FEAC37,#FD7324); /* Safari 5.1-6.0 */
            background: -o-linear-gradient(to right,#FEAC37,#FD7324); /* Opera 11.1-12.0 */
            background: -moz-linear-gradient(to right,#FEAC37,#FD7324); /* Firefox 3.6-15 */
            background: linear-gradient(to right,#FEAC37,#FD7324); /* 标准语法 */
        }
        .sumbit{
            width:50%;
            height:40px;
            margin:14px auto;
        }
    }
</style>